import AllSwimlanes from './AllSwimlanes';

export default AllSwimlanes;
